module.exports = __webpack_public_path__ + "static/media/mobile-product-1.2d631ba0.png";